@let externalWidgets = widgetWindows.externalWidgetIds$ | async;

@if (loggedUser && isMobileView && (widgetDataStore.widgets$ | async)?.length) {
  <swiper-container appSwiper #swiper animate.enter="adx-fade-in" [config]="swiperConfig" class="swiper-mobile-container" events-prefix="swiper-" init="false" (swiper-slidechange)="onSwiperSlideChange()">
      @for (widget of widgetDataStore.widgets$ | async; track widget._id) {
      <swiper-slide
        (touchstart)="onWidgetHover(widget)"
                  [ngClass]="{
                   'widget-in-fullscreen': widgetInFullscreen
                   }"
        #widgetItems
        >
        @if (renderWidgetHeader(widget)) {
          <!-- no fullscreen action here: the swiper already shows one widget at a time -->
          <app-widget-header class="swiper-slide-mobile-header"
           [ngClass]="{
            'always-displayed': widget.appPluginWidget.settings.widgetHeader.alwaysDisplayed,
            'always-displayed-off': widget.appPluginWidget.settings.widgetHeader.alwaysDisplayed && widgetInFullscreen && !widget.isHeaderHovered,
            'hover-displayed': widget.appPluginWidget.settings.widgetHeader.onHoverDisplayed,
            'adx-header-shown': widgetHeaderIsHovered(widget)
            }"
            [widget]="widget"
            variant="swiper"
            [canOpenSettings]="widgetDialogService.isConfigurable(widget) && widgetSettingsEnabled(widget)"
            [canRemove]="!!(widgetDataStore.edit$ | async)"
            (settingsOpen)="widgetDialogService.loadSettingComponent(widget, modelService, pluginInjectorService, dialog)"
            (removeRequest)="removeWidgetItem($event, widget)"
            (menuOpenChange)="onWidgetMenuOpenChange(widget, $event)"
            >
          </app-widget-header>
        }
        @if (showWidgetDivider(widget)) {
          <mat-divider></mat-divider>
        }
        <div class="swiper-item-content" [class.adx-header-hover-mode]="widget.appPluginWidget.settings.widgetHeader.onHoverDisplayed" [class.adx-header-overlaid]="widgetHeaderIsHovered(widget)">
          @if (externalWidgets?.has(widget._id)) {
            <app-widget-window-placeholder
              [widget]="widget"
              (focusRequest)="widgetWindows.focus(widget._id)"
              (bringBackRequest)="widgetWindows.bringBack(widget._id)"></app-widget-window-placeholder>
          } @else {
            <ng-template
              [appWidgetItem]="widget"
              [isHeaderHovered]="widgetHeaderIsHovered(widget)"></ng-template>
          }
        </div>
      </swiper-slide>
    }
  </swiper-container>
}


@if (loggedUser && !isMobileView) {
  <gridster [options]="widgetGridLayoutConfig.options" id="grid" animate.enter="adx-fade-in">
      @for (widget of widgetDataStore.widgets$ | async; track widget._id; let widgetIndex = $index) {
      <gridster-item
        [item]="widget"
        class="gridster-item"
        (mouseenter)="onWidgetHover(widget)"
        (mouseleave)="onWidgetHoverCancel(widget)"
        #widgetItems
                   [ngClass]="{
                   'widget-in-fullscreen': widgetInFullscreen
                   }">
        @if (renderWidgetHeader(widget)) {
          <app-widget-header class="adx-grid-item-header"
           [ngClass]="{
            'always-displayed': widget.appPluginWidget.settings.widgetHeader.alwaysDisplayed,
            'always-displayed-off': widget.appPluginWidget.settings.widgetHeader.alwaysDisplayed && widgetInFullscreen && !widget.isHeaderHovered,
            'hover-displayed': widget.appPluginWidget.settings.widgetHeader.onHoverDisplayed,
            'adx-header-shown': widgetHeaderIsHovered(widget)
            }"
            [widget]="widget"
            variant="grid"
            [isFullscreen]="widgetInFullscreen"
            [canToggleFullscreen]="!(widgetDataStore.edit$ | async) && !externalWidgets?.has(widget._id)"
            [canOpenInWindow]="widgetWindows.supported && !(widgetDataStore.edit$ | async) && !externalWidgets?.has(widget._id)"
            [canOpenSettings]="widgetDialogService.isConfigurable(widget) && widgetSettingsEnabled(widget) && !externalWidgets?.has(widget._id)"
            [canRemove]="!!(widgetDataStore.edit$ | async)"
            (fullscreenToggle)="toggleFullscreen(widgetIndex)"
            (openInWindow)="openInWindow(widget,  $event)"
            (settingsOpen)="widgetDialogService.loadSettingComponent(widget, modelService, pluginInjectorService, dialog)"
            (removeRequest)="removeWidgetItem($event, widget)"
            (menuOpenChange)="onWidgetMenuOpenChange(widget, $event)"
            >
          </app-widget-header>
        }
        @if (showWidgetDivider(widget)) {
          <mat-divider></mat-divider>
        }
        <div class="adx-grid-item-content" [class.adx-header-hover-mode]="widget.appPluginWidget.settings.widgetHeader.onHoverDisplayed" [class.adx-header-overlaid]="widgetHeaderIsHovered(widget)">
          @if (externalWidgets?.has(widget._id)) {
            <app-widget-window-placeholder
              [widget]="widget"
              (focusRequest)="widgetWindows.focus(widget._id)"
              (bringBackRequest)="widgetWindows.bringBack(widget._id)"></app-widget-window-placeholder>
          } @else {
            <ng-template
              [appWidgetItem]="widget"
              [isHeaderHovered]="widgetHeaderIsHovered(widget)"></ng-template>
          }
        </div>
      </gridster-item>
    }
  </gridster>
}
